export const getIsInIframe = () => window.self !== window.top;
